export default "__VITE_ASSET__BqIM6jlc__"